module.exports = __webpack_public_path__ + "static/media/icono_ganancias_activo.63c3b45c.svg";